import { AppDispatch } from 'store';
import { apiRequest } from 'utils/api';
import {
  GET_LODGING_REQUESTS_DATA_FAILURE,
  GET_LODGING_REQUESTS_DATA_REQUEST,
  GET_LODGING_REQUESTS_DATA_SUCCESS,
  GetLodgingRequestsData,
  GetLodgingRequestsParams,
} from 'store/reducers/lodgingRequest/get/types';
import {
  ViewLodgingRequestData,
  VIEW_LODGING_REQUESTS_DATA_FAILURE,
  VIEW_LODGING_REQUESTS_DATA_REQUEST,
  VIEW_LODGING_REQUESTS_DATA_SUCCESS,
} from 'store/reducers/lodgingRequest/view/types';
import {
  PreferredRoommatesData,
  PREFERRED_ROOMMATES_DATA_FAILURE,
  PREFERRED_ROOMMATES_DATA_REQUEST,
  PREFERRED_ROOMMATES_DATA_SUCCESS,
} from 'store/reducers/lodgingRequest/preferredRoommates/types';
import {
  CancelLodgingRequestData,
  CANCEL_LODGING_REQUEST_FAILURE,
  CANCEL_LODGING_REQUEST_REQUEST,
  CANCEL_LODGING_REQUEST_SUCCESS,
} from 'store/reducers/lodgingRequest/cancel/types';
import {
  ReopenLodgingRequestData,
  REOPEN_LODGING_REQUEST_FAILURE,
  REOPEN_LODGING_REQUEST_REQUEST,
  REOPEN_LODGING_REQUEST_SUCCESS,
} from 'store/reducers/lodgingRequest/reopen/types';
import {
  EditLodgingRequestData,
  EditLodgingRequestParams,
  EDIT_LODGING_REQUEST_DATA_FAILURE,
  EDIT_LODGING_REQUEST_DATA_REQUEST,
  EDIT_LODGING_REQUEST_DATA_SUCCESS,
} from 'store/reducers/lodgingRequest/edit/types';
import {
  GetGuestsForFilterData,
  GetGuestsForFilterParams,
  GET_GUESTS_FOR_FILTER_FAILURE,
  GET_GUESTS_FOR_FILTER_REQUEST,
  GET_GUESTS_FOR_FILTER_SUCCESS,
} from 'store/reducers/lodgingRequest/getGuestsForFilter/types';
import {
  GET_LODGING_REQUESTS_COUNT_DATA_FAILURE,
  GET_LODGING_REQUESTS_COUNT_DATA_REQUEST,
  GET_LODGING_REQUESTS_COUNT_DATA_SUCCESS,
} from 'store/reducers/lodgingRequest/get-count/types';
import {
  GET_LOCATION_DATA_FAILURE,
  GET_LOCATION_DATA_REQUEST,
  GET_LOCATION_DATA_SUCCESS,
  LocationData,
} from 'store/reducers/lodgingRequest/getLocationData/types';
import {
  GetFormData,
  GET_FORM_DATA_FAILURE,
  GET_FORM_DATA_REQUEST,
  GET_FORM_DATA_SUCCESS,
} from 'store/reducers/lodgingRequest/getFormData/types';
import {
  AddByManagerData,
  AddByManagerParams,
  ADD_BY_MANAGER_FAILURE,
  ADD_BY_MANAGER_REQUEST,
  ADD_BY_MANAGER_SUCCESS,
} from 'store/reducers/lodgingRequest/addByManager/types';
import {
  LodgingRequestExportExcelParams,
  LODGING_REQUEST_EXPORT_EXCEL_FAILURE,
  LODGING_REQUEST_EXPORT_EXCEL_REQUEST,
  LODGING_REQUEST_EXPORT_EXCEL_SUCCESS,
} from 'store/reducers/lodgingRequest/exportExcel/types';
import { AxiosResponse } from 'axios';
import fileDownload from 'js-file-download';
import {
  AllPreferredRoommatesData,
  ALL_PREFERRED_ROOMMATES_FAILURE,
  ALL_PREFERRED_ROOMMATES_REQUEST,
  ALL_PREFERRED_ROOMMATES_SUCCESS,
} from 'store/reducers/lodgingRequest/allPreferredRoommates/types';
import {
  READ_REQUESTS_FILTERS_FAILURE,
  READ_REQUESTS_FILTERS_REQUEST,
  READ_REQUESTS_FILTERS_SUCCESS,
  RequestsFiltersData,
} from 'store/reducers/lodgingRequest/readRequestsFilters/types';
import {
  CheckIfExistsData,
  CheckIfExistsParams,
  CHECK_IF_EXISTS_BY_ID_FAILURE,
  CHECK_IF_EXISTS_BY_ID_REQUEST,
  CHECK_IF_EXISTS_BY_ID_SUCCESS,
  CHECK_IF_EXISTS_FAILURE,
  CHECK_IF_EXISTS_REQUEST,
  CHECK_IF_EXISTS_SUCCESS,
  CheckIfExistsMassParams,
} from 'store/reducers/lodgingRequest/checkIfExists/types';
import { BaseTableRequest, Filters } from 'store/types';
import { SET_REQUEST_TABLE_FILTERS } from 'store/reducers/lodgingRequest/requestTableFilters/types';
import { CLONE_LODGING_REQUEST_FAILURE, CLONE_LODGING_REQUEST_REQUEST, CLONE_LODGING_REQUEST_SUCCESS, CloneLodgingRequestDatesData } from 'store/reducers/lodgingRequest/clone/types';
import { EditLodgingRequestDatesData, EditLodgingRequestDatesParams, EDIT_LODGING_REQUEST_DATES_FAILURE, EDIT_LODGING_REQUEST_DATES_REQUEST, EDIT_LODGING_REQUEST_DATES_SUCCESS } from 'store/reducers/lodgingRequest/edit-dates/types';
import { GET_LODGING_REQUEST_ACTIVITY_LOGS_FAILURE, GET_LODGING_REQUEST_ACTIVITY_LOGS_REQUEST, GET_LODGING_REQUEST_ACTIVITY_LOGS_SUCCESS } from 'store/reducers/lodgingRequest/get-activity-logs/types';
import { NoteForm } from 'store/reducers/activity-log/add-note/types';
import { GetReadyForAssignmentData, GET_READY_FOR_ASSIGNMENT_FAILURE, GET_READY_FOR_ASSIGNMENT_REQUEST, GET_READY_FOR_ASSIGNMENT_SUCCESS, ReadyForAssignmentData } from 'store/reducers/lodgingRequest/get-ready-for-assignment-data/types';
import { GET_LODGING_REQUESTS_ALL_COUNT_DATA_FAILURE, GET_LODGING_REQUESTS_ALL_COUNT_DATA_REQUEST, GET_LODGING_REQUESTS_ALL_COUNT_DATA_SUCCESS } from 'store/reducers/lodgingRequest/get-all-count/types';
import { SET_REQUEST_TABLE_COLUMNS } from 'store/reducers/lodgingRequest/request-table-columns/types';
import { REQUESTS_BY_CLIENT_FILTERS_FAILURE, REQUESTS_BY_CLIENT_FILTERS_REQUEST, REQUESTS_BY_CLIENT_FILTERS_SUCCESS } from 'store/reducers/lodgingRequest/get-requests-by-client-filters/types';
import { RequestsByClientParams, REQUESTS_BY_CLIENT_FAILURE, REQUESTS_BY_CLIENT_REQUEST, REQUESTS_BY_CLIENT_SUCCESS } from 'store/reducers/lodgingRequest/get-requests-by-client/types';
import { SET_REQUESTS_BY_CLIENT_TABLE_FILTERS } from 'store/reducers/lodgingRequest/requests-by-client-table-filters/types';
import { GetClientsForFilterData, GetClientsForFilterParams, GET_CLIENTS_FOR_FILTER_FAILURE, GET_CLIENTS_FOR_FILTER_REQUEST, GET_CLIENTS_FOR_FILTER_SUCCESS } from 'store/reducers/lodgingRequest/get-clients-for-filter/types';
import { GetLocationsForFilterData, GetLocationsForFilterParams, GET_LOCATIONS_FOR_FILTER_FAILURE, GET_LOCATIONS_FOR_FILTER_REQUEST, GET_LOCATIONS_FOR_FILTER_SUCCESS } from 'store/reducers/lodgingRequest/get-locations-for-filter/types';
import { GetMassActionsParams, MASS_ACTIONS_FAILURE, MASS_ACTIONS_REQUEST, MASS_ACTIONS_SUCCESS } from 'store/reducers/lodgingRequest/get-mass-actions/types';
import {
  SELECTED_FOR_MASS_BOOKING_FAILURE,
  SELECTED_FOR_MASS_BOOKING_REQUEST,
  SELECTED_FOR_MASS_BOOKING_SUCCESS,
  SelectedForMassBookingData
} from 'store/reducers/lodgingRequest/selected-for-mass-booking/types';
import { GET_SPLIT_FORM_DATA_FAILURE, GET_SPLIT_FORM_DATA_REQUEST, GET_SPLIT_FORM_DATA_SUCCESS } from 'store/reducers/lodgingRequest/get-split-form-data/types';
import { SplitRequestForm } from 'store/reducers/lodgingRequest/split/types';
import { MassAddNoteFormRequest as MassAddNoteForm } from 'store/reducers/activity-log/mass-add-note/types';
import {
  GET_BOOKINGS_BY_RESERVATIONS_REQUEST,
  GET_BOOKINGS_BY_RESERVATIONS_SUCCESS,
  GET_BOOKINGS_BY_RESERVATIONS_FAILURE,
  GetBookingsByReservationsData, BookingByReservationsData, SET_LOCATION_NAME
} from 'store/reducers/lodgingRequest/get-bookings-by-reservations/types';
import {
  RESEND_EMAIL_BY_NOTIFICATION_ID_REQUEST,
  RESEND_EMAIL_BY_NOTIFICATION_ID_FAILURE
} from 'store/reducers/lodgingRequest/resend-email-by-notification-id/types';
import {
  AllBookingsData, GET_ALL_BOOKINGS_FAILURE,
  GET_ALL_BOOKINGS_REQUEST, GET_ALL_BOOKINGS_SUCCESS,
  GetAllBookingsData
} from "store/reducers/lodgingRequest/get-all-bookings/types";
import { RoomGuest } from 'types/rooms/room-guest';
import {
  LODGING_REQUEST_REPORT_EXCEL_FAILURE,
  LODGING_REQUEST_REPORT_EXCEL_REQUEST,
  LODGING_REQUEST_REPORT_EXCEL_SUCCESS,
  LodgingRequestReportExcelParams
} from 'store/reducers/lodgingRequest/getReportExcel/types';

export function getLodgingRequestsData(params: GetLodgingRequestsParams): any {
  return async (dispatch: AppDispatch): Promise<GetLodgingRequestsData> => {
    dispatch({ type: GET_LODGING_REQUESTS_DATA_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/get`, {
        data: params,
      });
      dispatch({
        type: GET_LODGING_REQUESTS_DATA_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: GET_LODGING_REQUESTS_DATA_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export async function getLodgingRequestsWithoutStore(data: GetLodgingRequestsParams): Promise<GetLodgingRequestsData> {
  try {
    const response = await apiRequest('post', `lodging-request/get`, { data });
    return response?.data || {};
  } catch (response: any) {
    throw response;
  }
}

export function viewLodgingRequest(id: string): any {
  return async (dispatch: AppDispatch): Promise<ViewLodgingRequestData> => {
    dispatch({ type: VIEW_LODGING_REQUESTS_DATA_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/view/${id}`);
      dispatch({
        type: VIEW_LODGING_REQUESTS_DATA_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: VIEW_LODGING_REQUESTS_DATA_FAILURE,
        error,
      });

      const errorMessage =
        response?.data?.error && Array.isArray(response.data.error)
          ? response.data.error[0]
          : response?.data?.error || 'Unknown error';

      throw new Error(errorMessage);
    }
  };
}

export function editLodgingRequestDates(params: EditLodgingRequestDatesParams): any {
  return async (dispatch: AppDispatch): Promise<EditLodgingRequestDatesData> => {
    dispatch({ type: EDIT_LODGING_REQUEST_DATES_REQUEST });

    try {
      const response = await apiRequest('put', `lodging-request/edit-dates`, {
        data: params,
      });
      dispatch({
        type: EDIT_LODGING_REQUEST_DATES_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: EDIT_LODGING_REQUEST_DATES_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function editLodgingRequest(params: EditLodgingRequestParams): any {
  return async (dispatch: AppDispatch): Promise<EditLodgingRequestData> => {
    dispatch({ type: EDIT_LODGING_REQUEST_DATA_REQUEST });

    try {
      const response = await apiRequest('put', `lodging-request/edit`, {
        data: params,
      });
      dispatch({
        type: EDIT_LODGING_REQUEST_DATA_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: EDIT_LODGING_REQUEST_DATA_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function reopenLodgingRequest(id: string): any {
  return async (dispatch: AppDispatch): Promise<ReopenLodgingRequestData> => {
    dispatch({ type: REOPEN_LODGING_REQUEST_REQUEST });

    try {
      const response = await apiRequest('put', `lodging-request/reopen`, {
        data: { id },
      });
      dispatch({
        type: REOPEN_LODGING_REQUEST_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: REOPEN_LODGING_REQUEST_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function cancelLodgingRequest(id: string, doNotSendNotification: boolean): any {
  return async (dispatch: AppDispatch): Promise<CancelLodgingRequestData> => {
    dispatch({ type: CANCEL_LODGING_REQUEST_REQUEST });

    try {
      const response = await apiRequest('put', `lodging-request/${id}/cancel`, { data: { doNotSendNotification } });
      dispatch({
        type: CANCEL_LODGING_REQUEST_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: CANCEL_LODGING_REQUEST_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function preferredRoommates(id: string): any {
  return async (dispatch: AppDispatch): Promise<PreferredRoommatesData> => {
    dispatch({ type: PREFERRED_ROOMMATES_DATA_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/preferred-roommates/${id}`);
      dispatch({
        type: PREFERRED_ROOMMATES_DATA_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: PREFERRED_ROOMMATES_DATA_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function getGuestsForFilter(params: GetGuestsForFilterParams): any {
  return async (dispatch: AppDispatch): Promise<GetGuestsForFilterData> => {
    dispatch({ type: GET_GUESTS_FOR_FILTER_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/get-guests-for-filter`, {
        data: params,
      });
      dispatch({
        type: GET_GUESTS_FOR_FILTER_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: GET_GUESTS_FOR_FILTER_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function getLodgingRequestsCount(data: Filters): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_LODGING_REQUESTS_COUNT_DATA_REQUEST });
    try {
      const response = await apiRequest('post', `lodging-request/get-count`, { data });
      dispatch({ type: GET_LODGING_REQUESTS_COUNT_DATA_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_LODGING_REQUESTS_COUNT_DATA_FAILURE, error });
      throw response;
    }
  };
}

export function getLocationData(id: string): any {
  return async (dispatch: AppDispatch): Promise<LocationData> => {
    dispatch({ type: GET_LOCATION_DATA_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/get-location-data/${id}`);
      dispatch({
        type: GET_LOCATION_DATA_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: GET_LOCATION_DATA_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function getFormData(id?: string): any {
  return async (dispatch: AppDispatch): Promise<GetFormData> => {
    dispatch({ type: GET_FORM_DATA_REQUEST });

    try {
      const response = await apiRequest('get', id ? `lodging-request/get-form-data/${id}` : 'lodging-request/get-form-data');
      dispatch({
        type: GET_FORM_DATA_SUCCESS,
        contents: response?.data,
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: GET_FORM_DATA_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function addByManager(params: AddByManagerParams): any {
  return async (dispatch: AppDispatch): Promise<AddByManagerData> => {
    dispatch({ type: ADD_BY_MANAGER_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/add-by-manager`, {
        data: params,
      });
      dispatch({
        type: ADD_BY_MANAGER_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ADD_BY_MANAGER_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export async function addNote(id: string, data: NoteForm) {
  try {
    await apiRequest('post', `lodging-request/${id}/notes/add`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function editNote(id: string, noteId: string, data: NoteForm) {
  try {
    await apiRequest('put', `lodging-request/${id}/notes/${noteId}/edit`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function deleteNote(id: string, noteId: string) {
  try {
    await apiRequest('delete', `lodging-request/${id}/notes/${noteId}`);
  } catch (response: any) {
    throw response;
  }
}

export function getActivityLogs(id: string, data: BaseTableRequest): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_LODGING_REQUEST_ACTIVITY_LOGS_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/${id}/get-activity-logs`, { data });
      dispatch({ type: GET_LODGING_REQUEST_ACTIVITY_LOGS_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_LODGING_REQUEST_ACTIVITY_LOGS_FAILURE, error });
      throw response;
    }
  };
}

export function allPreferredRoommates(id: string): any {
  return async (dispatch: AppDispatch): Promise<AllPreferredRoommatesData> => {
    dispatch({ type: ALL_PREFERRED_ROOMMATES_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/all-preferred-roommates/${id}`);

      dispatch({
        type: ALL_PREFERRED_ROOMMATES_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ALL_PREFERRED_ROOMMATES_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function allPreferredRoommatesWithCurrent(id: string): any {
  return async (dispatch: AppDispatch): Promise<AllPreferredRoommatesData> => {
    dispatch({ type: ALL_PREFERRED_ROOMMATES_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/all-preferred-roommates/${id}`);

      dispatch({
        type: ALL_PREFERRED_ROOMMATES_SUCCESS,
        contents: response ? [{ id: id }, ...response?.data] : {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ALL_PREFERRED_ROOMMATES_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function exportExcel(params: LodgingRequestExportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: LODGING_REQUEST_EXPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = (await apiRequest(
        'post',
        `lodging-request/export-excel`,
        {
          responseType: 'blob',
          data: params,
        }
      )) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Requests.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: LODGING_REQUEST_EXPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LODGING_REQUEST_EXPORT_EXCEL_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function getReportExcel(params: LodgingRequestReportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: LODGING_REQUEST_REPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = (await apiRequest(
        'post',
        `lodging-request/get-report-excel`,
        {
          responseType: 'blob',
          data: params,

        }
      )) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Requests.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: LODGING_REQUEST_REPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LODGING_REQUEST_REPORT_EXCEL_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export async function setPending(id: string, data: NoteForm) {
  try {
    await apiRequest('put', `lodging-request/${id}/set-pending`, { data });
  } catch (response: any) {
    throw response;
  }
}

export function readRequestsFilters(): any {
  return async (dispatch: AppDispatch): Promise<RequestsFiltersData> => {
    dispatch({ type: READ_REQUESTS_FILTERS_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/get-table-filters`);
      dispatch({
        type: READ_REQUESTS_FILTERS_SUCCESS,
        contents: response?.data || {},
      });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({
        type: READ_REQUESTS_FILTERS_FAILURE,
        error,
      });
      throw response;
    }
  };
}

export function checkIfExists(params: CheckIfExistsParams): any {
  return async (dispatch: AppDispatch): Promise<CheckIfExistsData> => {
    dispatch({ type: CHECK_IF_EXISTS_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/check-if-exists`, {
        data: params,
      });

      dispatch({
        type: CHECK_IF_EXISTS_SUCCESS,
        exists: response?.data.exists,
        existingRequestData: response?.data?.messageData,
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: CHECK_IF_EXISTS_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function checkIfExistsMass(data: CheckIfExistsMassParams): any {
  return async (dispatch: AppDispatch): Promise<CheckIfExistsData> => {
    dispatch({ type: CHECK_IF_EXISTS_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/check-if-exists-mass`, {
        data: data,
      });

      dispatch({
        type: CHECK_IF_EXISTS_SUCCESS,
        exists: response?.data.exists,
        existingRequestData: response?.data?.messageData,
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: CHECK_IF_EXISTS_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function checkIfExistsById(id: string): any {
  return async (dispatch: AppDispatch): Promise<CheckIfExistsData> => {
    dispatch({ type: CHECK_IF_EXISTS_BY_ID_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/check-if-exists/${id}`);

      dispatch({
        type: CHECK_IF_EXISTS_BY_ID_SUCCESS,
        exists: response?.data.exists,
        existingRequestData: response?.data?.messageData,
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: CHECK_IF_EXISTS_BY_ID_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function setRequestTableFilters(filters: Filters): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: SET_REQUEST_TABLE_FILTERS,
        contents: filters,
        exists: Object.keys(filters).some(key => filters[key]),
      });
    } catch { }
  };
}

export function clone(params: AddByManagerParams): any {
  return async (dispatch: AppDispatch): Promise<AddByManagerData> => {
    dispatch({ type: CLONE_LODGING_REQUEST_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/clone`, {
        data: params,
      });
      dispatch({
        type: CLONE_LODGING_REQUEST_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: CLONE_LODGING_REQUEST_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function getReadyForAssignmentData(data: GetReadyForAssignmentData): any {
  return async (dispatch: AppDispatch): Promise<ReadyForAssignmentData[]> => {
    dispatch({ type: GET_READY_FOR_ASSIGNMENT_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-request/get-ready-for-assignment-data`, { data });
      dispatch({
        type: GET_READY_FOR_ASSIGNMENT_SUCCESS,
        contents: response?.data || {},
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: GET_READY_FOR_ASSIGNMENT_FAILURE,
        error,
      });

      throw response;
    }
  };
}

export function emptyReadyForAssignmentData(): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: GET_READY_FOR_ASSIGNMENT_SUCCESS, contents: [] });
    } catch { }
  };
};

export function getLodgingRequestsAllCount(): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_LODGING_REQUESTS_ALL_COUNT_DATA_REQUEST });
    try {
      const response = await apiRequest('get', `lodging-request/get-all-count`);
      dispatch({ type: GET_LODGING_REQUESTS_ALL_COUNT_DATA_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_LODGING_REQUESTS_ALL_COUNT_DATA_FAILURE, error });
      throw response;
    }
  };
}

export function getBookingsByReservations(data: GetBookingsByReservationsData): any {
  return async (dispatch: AppDispatch): Promise<BookingByReservationsData[]> => {
    dispatch({ type: GET_BOOKINGS_BY_RESERVATIONS_REQUEST });
    try {
      const response = await apiRequest('post', `lodging-request/get-bookings-by-reservations`, { data });
      dispatch({ type: GET_BOOKINGS_BY_RESERVATIONS_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_BOOKINGS_BY_RESERVATIONS_FAILURE, error });
      throw response;
    }
  };
}

export function getAllBookings(data: GetAllBookingsData): any {
  return async (dispatch: AppDispatch): Promise<AllBookingsData[]> => {
    dispatch({ type: GET_ALL_BOOKINGS_REQUEST });
    try {
      const response = await apiRequest('post', `lodging-request/get-all-bookings`, { data });
      dispatch({ type: GET_ALL_BOOKINGS_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_ALL_BOOKINGS_FAILURE, error });
      throw response;
    }
  };
}

export function setRequestTableColumns(columns: string[]): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: SET_REQUEST_TABLE_COLUMNS, contents: columns });
    } catch { }
  };
}

export function readRequestsByClientFilters(): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: REQUESTS_BY_CLIENT_FILTERS_REQUEST });
    try {
      const response = await apiRequest('get', 'lodging-request/get-requests-by-client-table-filters');
      dispatch({ type: REQUESTS_BY_CLIENT_FILTERS_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: REQUESTS_BY_CLIENT_FILTERS_FAILURE, error });
      throw response;
    }
  };
}

export function getRequestsByClient(data: RequestsByClientParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: REQUESTS_BY_CLIENT_REQUEST });
    try {
      const response = await apiRequest('post', `lodging-request/get-requests-by-client`, { data });
      dispatch({ type: REQUESTS_BY_CLIENT_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: REQUESTS_BY_CLIENT_FAILURE, error });
      throw response;
    }
  };
}

export function setRequestsByClientTableFilters(filters: Filters): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: SET_REQUESTS_BY_CLIENT_TABLE_FILTERS,
        contents: filters,
        exists: Object.keys(filters).some(key => filters[key]),
      });
    } catch { }
  };
}

export function getClientsForFilter(data: GetClientsForFilterParams): any {
  return async (dispatch: AppDispatch): Promise<GetClientsForFilterData> => {
    dispatch({ type: GET_CLIENTS_FOR_FILTER_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-request/get-clients-for-filter', { data });
      dispatch({ type: GET_CLIENTS_FOR_FILTER_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_CLIENTS_FOR_FILTER_FAILURE, error });
      throw response;
    }
  };
}

export function getLocationsForFilter(data: GetLocationsForFilterParams): any {
  return async (dispatch: AppDispatch): Promise<GetLocationsForFilterData> => {
    dispatch({ type: GET_LOCATIONS_FOR_FILTER_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-request/get-locations-for-filter', { data });
      dispatch({ type: GET_LOCATIONS_FOR_FILTER_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_LOCATIONS_FOR_FILTER_FAILURE, error });
      throw response;
    }
  };
}

export function getMassActions(data: GetMassActionsParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: MASS_ACTIONS_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-request/get-mass-actions', { data });
      dispatch({ type: MASS_ACTIONS_SUCCESS, contents: response?.data || [] });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: MASS_ACTIONS_FAILURE, error });
      throw response;
    }
  };
}

export async function massCancel(requestsIds: string[], doNotSendNotification: boolean): Promise<void> {
  try {
    await apiRequest('put', `lodging-request/mass-cancel`, { data: { requestsIds, doNotSendNotification } });
  } catch (response: any) {
    throw response;
  }
}

export async function massEditDates(data: EditLodgingRequestDatesData): Promise<void> {
  try {
    await apiRequest('put', `lodging-request/mass-edit-dates`, { data });
  } catch (response: any) {
    throw response;
  }
}

export function getSelectedForMassBookingData(requestsIds: string[]): any {
  return async (dispatch: AppDispatch): Promise<SelectedForMassBookingData> => {
    dispatch({ type: SELECTED_FOR_MASS_BOOKING_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-request/get-selected-for-mass-booking', { data: { requestsIds } });
      dispatch({ type: SELECTED_FOR_MASS_BOOKING_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: SELECTED_FOR_MASS_BOOKING_FAILURE, error });
      throw response;
    }
  };
}

export async function updateFlagged(id: string, data: NoteForm) {
  await apiRequest('put', `lodging-request/${id}/update-flagged`, { data });
}

export function getSplitFormData(id: string): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_SPLIT_FORM_DATA_REQUEST });

    try {
      const response = await apiRequest('get', `lodging-request/${id}/split-form-data`);
      dispatch({ type: GET_SPLIT_FORM_DATA_SUCCESS, contents: response?.data });
    } catch (response: any) {
      dispatch({ type: GET_SPLIT_FORM_DATA_FAILURE, error: response && (response as any).error });
      throw response;
    }
  };
}

export async function split(id: string, data: SplitRequestForm): Promise<RoomGuest> {
  try {
    const response = await apiRequest('post', `lodging-request/${id}/split`, { data });
    return response?.data;
  } catch (response: any) {
    throw response;
  }
}

export async function massAddNote(data: MassAddNoteForm) {
  try {
    await apiRequest('post', `lodging-request/notes/mass-add`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function massClone(data: CloneLodgingRequestDatesData) {
  try {
    await apiRequest('put', `lodging-request/mass-clone`, { data });
  } catch (response: any) {
    throw response;
  }
}

export function resendEmailByNotificationId(notificationId: string): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: RESEND_EMAIL_BY_NOTIFICATION_ID_REQUEST });
    try {
      await apiRequest('post', 'lodging-request/resend-email-by-notification-id', { data: { id: notificationId } });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: RESEND_EMAIL_BY_NOTIFICATION_ID_FAILURE, error });
      throw response;
    }
  };
}

export function setLocationName(name: string): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: SET_LOCATION_NAME, name });
    } catch { }
  };
}